import Seo from "@/lib/Seo";
import { useSite } from "@/context/SiteContext";
import Reveal from "@/components/Reveal";

const PAGES = {
  "mentions-legales": {
    title: "Mentions légales",
    path: "/mentions-legales",
    sections: [
      { h: "Éditeur du site", p: "DOUZIEME HOMME LE JEU — SAS au capital de 100 €\nSIRET : 991 190 760\nSiège social : 50 boulevard Stalingrad, 06300 Nice, France\nEmail : contact@douziemehomme-lejeu.com\nTéléphone : +33 6 52 88 21 60" },
      { h: "Site", p: "douziemehomme-lejeu.com" },
      { h: "Produit", p: "Douzième Homme — Le Jeu · Édition Nice. Conçu à Nice, fabriqué en France." },
    ],
  },
  cgv: {
    title: "Conditions Générales de Vente",
    path: "/cgv",
    sections: [
      { h: "Vendeur", p: "DOUZIEME HOMME LE JEU — SAS au capital de 100 € — SIRET 991 190 760 — 50 boulevard Stalingrad, 06300 Nice, France.\nContact : contact@douziemehomme-lejeu.com — +33 6 52 88 21 60." },
      { h: "Produits et prix", p: "Les prix sont indiqués en euros, toutes taxes comprises (TTC). Les offres en vigueur sont celles affichées sur la page « Acheter » au moment de la commande." },
      { h: "Livraison et retrait", p: "Livraison en point relais sous 48h, ou retrait gratuit sous 24h dans les points de retrait partenaires à Nice, selon le mode choisi lors de la commande." },
      { h: "Droit de rétractation", p: "Conformément à la réglementation en vigueur, vous disposez d'un délai de 14 jours après réception pour exercer votre droit de rétractation. Contact : contact@douziemehomme-lejeu.com." },
    ],
  },
  "politique-confidentialite": {
    title: "Politique de confidentialité",
    path: "/politique-confidentialite",
    sections: [
      { h: "Responsable de traitement", p: "DOUZIEME HOMME LE JEU — SAS — 50 boulevard Stalingrad, 06300 Nice, France — contact@douziemehomme-lejeu.com." },
      { h: "Données collectées", p: "Formulaires de contact et de demande de devis entreprise : nom, email, téléphone et message. Ces données servent uniquement à répondre à vos demandes et ne sont ni vendues ni partagées avec des tiers." },
      { h: "Vos droits (RGPD)", p: "Vous disposez d'un droit d'accès, de rectification, d'opposition et de suppression de vos données. Pour l'exercer : contact@douziemehomme-lejeu.com." },
    ],
  },
  "politique-cookies": {
    title: "Politique cookies",
    path: "/politique-cookies",
    sections: [
      { h: "Cookies utilisés", p: "Le site public n'utilise pas de cookie de suivi ou publicitaire. Un cookie technique d'authentification sécurisé (httpOnly) est utilisé uniquement pour l'espace d'administration du propriétaire." },
      { h: "Gestion", p: "Aucune bannière de consentement n'est nécessaire en l'absence de cookies non essentiels. Cette page sera mise à jour si des outils de mesure d'audience sont ajoutés." },
    ],
  },
};

export default function Legal({ page }) {
  const { settings } = useSite();
  const conf = PAGES[page];
  if (!conf) return null;
  return (
    <>
      <Seo title={conf.title} path={conf.path} description={`${conf.title} — Douzième Homme Le Jeu, Édition Nice.`} />
      <section className="py-14 sm:py-20" data-testid={`legal-${page}`}>
        <div className="container-x max-w-3xl">
          <Reveal>
            <p className="eyebrow mb-4">Informations légales</p>
            <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight uppercase leading-[1.05] text-onyx mb-12">
              {conf.title}
            </h1>
          </Reveal>
          <div className="space-y-10">
            {conf.sections.map((s) => (
              <Reveal key={s.h}>
                <h2 className="font-display text-xl font-bold text-onyx mb-3">{s.h}</h2>
                <div className="text-sm sm:text-base text-muted-foreground leading-relaxed space-y-2">
                  {s.p.split("\n").map((line, i) => <p key={i}>{line}</p>)}
                </div>
              </Reveal>
            ))}
            <Reveal>
              <p className="text-xs text-muted-foreground border-t border-line pt-6">
                {settings?.legal_form} · SIRET {settings?.siret} · {settings?.address}
              </p>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}
